import { createApp } from 'vue'
import ZlMessage from '../layouts/ZlMessage.vue'

let messageInstance = null
let messageContainer = null

// 创建消息实例
const createMessageInstance = () => {
  if (messageInstance) {
    return messageInstance
  }

  // 创建容器
  messageContainer = document.createElement('div')
  messageContainer.id = 'zl-message-container'
  document.body.appendChild(messageContainer)

  // 创建Vue应用实例
  const app = createApp(ZlMessage)
  const instance = app.mount(messageContainer)
  
  messageInstance = instance
  return instance
}

// 获取消息实例
const getInstance = () => {
  return messageInstance || createMessageInstance()
}

// 全局消息方法
export const message = {
  success: (title, content, options) => {
    const instance = getInstance()
    return instance.success(title, content, options)
  },
  
  error: (title, content, options) => {
    const instance = getInstance()
    return instance.error(title, content, options)
  },
  
  warning: (title, content, options) => {
    const instance = getInstance()
    return instance.warning(title, content, options)
  },
  
  info: (title, content, options) => {
    const instance = getInstance()
    return instance.info(title, content, options)
  },
  
  // 自定义消息
  add: (options) => {
    const instance = getInstance()
    return instance.addMessage(options)
  },
  
  // 移除消息
  remove: (id) => {
    const instance = getInstance()
    return instance.removeMessage(id)
  },
  
  // 清空所有消息
  clear: () => {
    const instance = getInstance()
    return instance.clearAll()
  }
}

// Vue插件安装方法
export const ZlMessagePlugin = {
  install(app) {
    // 全局属性
    app.config.globalProperties.$message = message
    
    // 提供注入
    app.provide('$message', message)
  }
}

// 默认导出
export default message